/* product-gallery-arrows.js — Atelier Cohen-Dubois — v2
   Fleches de navigation sur l'image principale, DESKTOP UNIQUEMENT.
   S'appuie sur l'API native du theme : mediaGallery.setActiveMedia(mediaId, false).

   v2 : attend customElements.whenDefined('media-gallery'). La v1 pouvait s'executer
        avant media-gallery.js, auquel cas setActiveMedia n'existait pas encore
        et le script sortait en silence. */
(function () {
  var BP = window.matchMedia('(min-width: 990px)');

  function build(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'acd-gallery-arrow acd-gallery-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Image precedente' : 'Image suivante');
    b.innerHTML = dir === 'prev'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function init(gallery) {
    if (gallery.dataset.acdArrows) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    if (typeof gallery.setActiveMedia !== 'function') return;

    /* Uniquement les <li> de la galerie : les boutons de zoom portent aussi data-media-id. */
    var slides = function () {
      return Array.prototype.slice.call(viewer.querySelectorAll('li[data-media-id]'));
    };
    if (slides().length < 2) return;          /* une seule photo : pas de fleches */
    gallery.dataset.acdArrows = '1';

    var go = function (dir, e) {
      e.preventDefault();
      e.stopPropagation();                     /* n'ouvre pas la lightbox */
      var list = slides();
      var i = -1;
      for (var n = 0; n < list.length; n++) { if (list[n].classList.contains('is-active')) { i = n; break; } }
      if (i < 0) i = 0;
      var next = dir === 'prev' ? (i - 1 + list.length) % list.length : (i + 1) % list.length;
      gallery.setActiveMedia(list[next].dataset.mediaId, false);
    };

    var prev = build('prev');
    var nextBtn = build('next');
    prev.addEventListener('click', function (e) { go('prev', e); });
    nextBtn.addEventListener('click', function (e) { go('next', e); });

    if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
    viewer.appendChild(prev);
    viewer.appendChild(nextBtn);
  }

  function run() {
    if (!BP.matches) return;
    document.querySelectorAll('media-gallery').forEach(init);
  }

  function boot() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    if (BP.addEventListener) BP.addEventListener('change', run);
    document.addEventListener('shopify:section:load', run);
  }

  if (window.customElements) customElements.whenDefined('media-gallery').then(boot);
  else boot();
})();
